import { useTranslation } from 'react-i18next'
import { List, ListItemText, ListProps, ListItemButton } from '@mui/material'
import { RuuviTag } from '../types'
import RuuviTagType from '../enums/RuuviTagType'
import { formatMacAddress } from '../utils/string'
import { translateRuuviTagType, translateRuuviTagTypeValue } from '../utils/ruuviTag'

interface RuuviTagDetailsListProps extends Omit<ListProps, 'children'> {
  ruuviTag: RuuviTag
  showType?: boolean
  showDevice?: boolean
  typeOverride?: RuuviTagType | null
}

export default function RuuviTagDetailsList({
  ruuviTag,
  showType = true,
  showDevice = true,
  typeOverride,
  ...props
}: RuuviTagDetailsListProps) {
  /**
   * The translate function.
   */
  const { t } = useTranslation('ruuvitag')

  return (
    <List {...props}>
      {ruuviTag?.asset?.name && (
        <ListItemButton>
          <ListItemText primary={ruuviTag.asset.name} secondary={t('name')} />
        </ListItemButton>
      )}

      {ruuviTag?.asset?.company?.name && (
        <ListItemButton>
          <ListItemText primary={ruuviTag.asset.company.name} secondary={t('owner')} />
        </ListItemButton>
      )}

      {ruuviTag?.asset?.project?.name && (
        <ListItemButton>
          <ListItemText primary={ruuviTag.asset.project.name} secondary={t('project')} />
        </ListItemButton>
      )}

      {ruuviTag?.asset?.level?.name && (
        <ListItemButton>
          <ListItemText primary={ruuviTag.asset.level.name} secondary={t('level')} />
        </ListItemButton>
      )}

      {ruuviTag?.asset?.lift?.name && (
        <ListItemButton>
          <ListItemText primary={ruuviTag.asset.lift.name} secondary={t('lift')} />
        </ListItemButton>
      )}

      <ListItemButton>
        <ListItemText primary={formatMacAddress(ruuviTag.id)} secondary={t('macAddress')} />
      </ListItemButton>

      {showType && (
        <ListItemButton>
          <ListItemText
            primary={
              typeOverride !== undefined && typeOverride !== null
                ? translateRuuviTagTypeValue(typeOverride)
                : translateRuuviTagType(ruuviTag)
            }
            secondary={t('type')}
          />
        </ListItemButton>
      )}

      {showDevice && ruuviTag?.deviceName && (
        <ListItemButton>
          <ListItemText
            primary={ruuviTag.device?.asset?.name ?? ruuviTag.deviceName}
            secondary={t('hostDevice')}
          />
        </ListItemButton>
      )}

      {/*{ruuviTag?.createdAt && (
        <ListItemButton>
          <ListItemText
            primary={humanizeTimestamp(ruuviTag.createdAt)}
            secondary={t('createdAt')}
          />
        </ListItemButton>
      )}*/}
    </List>
  )
}
